/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { noop } from 'lodash';

export interface VisibilityFilterChangeEvent {
  checked: boolean;
}

@Component({
  standalone: false,
  selector: 'gh-visibility-filter',
  templateUrl: 'visibility-filter.component.html',
  styleUrls: ['visibility-filter.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: VisibilityFilterComponent, multi: true }],
})
export class VisibilityFilterComponent implements ControlValueAccessor {
  @Input() checked: boolean;
  @Input() disabled: boolean = false;

  @Output() change = new EventEmitter<VisibilityFilterChangeEvent>();

  private _onChange: (value: boolean) => void = noop;
  private _onTouched: (value: boolean) => void = noop;

  onChange(checked: boolean): void {
    this.checked = checked;

    this._onChange(checked);
    this._onTouched(checked);
    this.change.emit({ checked });
  }

  writeValue(obj: any): void {
    this.checked = obj;
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
